import React, { useEffect } from 'react';
import {
    Box,
    CircularProgress,
    ListItem,
    Card,
    CardContent,
} from '@mui/material';
import Helper from '../../../utility/helper';
import ApiHelper from '../../../utility/ApiHelper';
import APIURLConstants from '../../../config/config';
import RouteConstants from '../../../constants/routeConstants';
import Title from '../../../sharedcomponents/title/title';
import { createTheme } from '@mui/material/styles';
const theme = createTheme();
import { makeStyles } from '@mui/styles';
import UserMediaCircuitList from './userMediaCircuitList';
import CustomizedSnackbars from '../../../sharedcomponents/snackbar/snackBar';

const useStyles = makeStyles(() => ({
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    rowContent: {
        textAlign: 'center',
    },
    paperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
}));

const MarkActivitiyList = (props) => {
    const classes = useStyles();
    const eventInfo = Helper.getStorage('eventInfo');
    const [userModulePermissions, setUserModulePermissions] = React.useState({
        columns: [],
        rows: [],
    });
    const [loading, setLoading] = React.useState(false);

    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [selectedActivityID, setSelectedActivityID] = React.useState(0);
    const [usersData, setUsersData] = React.useState();

    const [activityData, setActivityData] = React.useState([]);

    useEffect(() => {
        getAllData();
    }, []);
    const generateExcelReport = async () => {
        let selectedIds = [];
        let IDs = null;
        let data = [];
        let finalData = [];
        // console.log('userModulePermissions', userModulePermissions);
        if (usersData.length > 0) {
            usersData.map((item) => {
                selectedIds.push(item.userID);
            });
            IDs = selectedIds.join(',');
        }
        // let data = [];
        // if(userModulePermissions && userModulePermissions.columns.length > 0 && userModulePermissions.rows.length > 0){
        //     console.log("columns",userModulePermissions.columns,"rows",userModulePermissions.rows);
        //     let header = [];
        //     let obj = {};
        //     let rowObjs = [];
        //     let rowData = [];
        //     let newArr = []
        //     userModulePermissions.rows.map((row, index) => {

        //             userModulePermissions.columns.map((col) =>{
        //                 // console.log("index1",index,index1);
        //                 let value = row[col.id];
        //                 // colID = col.id
        //                 if(value.label !== 'All Modules' && col.id !== 'completedOn' && value.label !== null)
        //                 {
        //                     // console.log("value",value);
        //                     if(value['permission'] !== undefined || value['permission'] !== null){
        //                         // rowObjs[value.label] = value['permission'];
        //                         rowObjs.push({
        //                                 [value.label] : value['permission']
        //                         })
        //                     }
        //                     if(col.id !== 'allModules' && col.id !== 'completedOn')
        //                     obj[col.label] = col.label;
        //                 }
        //             })

        //             if(index){
        //                 rowObjs.map((val) => {
        //                     console.log("val",val);
        //                     newArr.push(val)
        //                 })
        //             }
        //             console.log("rowObjs",rowObjs);

        //     })
        //     console.log("newArr",newArr);
        //     //         rowData.push(rowObjs)
        //     // console.log("rowObjs",rowObjs);
        //     header.push(obj);
        //     console.log("header",header, 'row', rowData);
        // }
        await ApiHelper.post(
            APIURLConstants.Excel_Export,
            {EventID:eventInfo.eventID, ModuleID:24, IDs:IDs}
        ).then((res) => {
            const finalObject = JSON.parse(res.data.value);
            const newModuleStatus =
                finalObject &&
                finalObject.filter((val) => val.activityTrackerID !== 0);
            //console.log(newModuleStatus);
            let result = newModuleStatus.reduce(function (r, c) {
                r[c.UserID] = r[c.UserID] || {
                    userID: c.UserID,
                    participant: c.Participant,
                    activity: [],
                };
                r[c.UserID].activity.push({
                    location: c.Location,
                    status: c.Status,
                    name: c.Name,
                    scheduleDateTime: c.ScheduleDateTime,
                });
                return r;
            }, {});
            //console.log('----------->', Object.values(result));

            Object.values(result) &&
                Object.values(result).map((key) => {
                    data = {
                        Participant: key.participant,
                    };
                    key.activity &&
                        key.activity.length > 0 &&
                        key.activity.map((val) => {
                            data = {
                                ...data,
                                [val.name]: val.status,
                            };
                        });
                    finalData.push(data);

                    // console.log(data);
                });
            // console.log(data);
            // const objectTags = Object.fromEntries(
            //     finalData && finalData[0].map((t) => [t, t])
            // );
            // const objectTags =
            //     finalData &&
            //     finalData[0].map((a) => a[Object.getOwnPropertyNames(a)]);
            // console.log('objectTags', objectTags);
            let header = [];
            header.push({ name: 'Participant' });
            if (activityData && activityData.length > 0) {
                activityData.forEach(function (k) {
                    header.push({ name: k.name });
                });
            }

            const headerTags = Object.fromEntries(
                header.map((t) => [t.name, t.name])
            );

            finalData.unshift(headerTags);

            // console.log(headerTags);
            Helper.downloadReport(finalData, `ActivityTracker`);
        });
    };
    const onChangeMediaCircuitActivities = (event) => {
        setSelectedActivityID(event.target.value);
        const modulesInfo = ApiHelper.get(
            APIURLConstants.GET_ACTIVITY_TRACKER_MARK_ACTIVITY_LIST(eventInfo.eventID)
        );
        const userModulesInfo = ApiHelper.get(
            APIURLConstants.GET_EVENT_ACTIVITY_TRACKER_MARK_ACTIVITIES(
                eventInfo.eventID
            )
        );
        let newUserModulePermissions = {
            columns: [],
            rows: [],
        };
        setLoading(false);
        Promise.all([modulesInfo, userModulesInfo]).then((result) => {
            let modules =
                event.target.value == 0
                    ? result[0].data
                    : result[0].data.filter(
                        (user) => user.activityTrackerID === event.target.value
                    );
            const users = result[1].data;
            setUsersData(users);
            if (modules.length > 0 && users.length > 0) {
                newUserModulePermissions.columns.push({
                    id: 'userName',
                    label: 'User',
                    activityTrackerID: 0,
                    showPermission: false,
                    permission: null,
                    align: 'left',
                    completedCount:0,  
                    inCompletedCount:0, 
                });
                newUserModulePermissions.columns.push({
                    id: 'tags',
                    label: 'Tags',
                    activityTrackerID: 0,
                    showPermission: false,
                    permission: null,
                    align: 'center',
                    completedCount:0,  
                    inCompletedCount:0, 
                });
                newUserModulePermissions.columns.push({
                    id: 'allModules',
                    label: 'All Media Circuit',
                    activityTrackerID: 0,
                    showPermission: true,
                    permission: null,
                    align: 'center',
                    completedCount:0,  
                    inCompletedCount:0, 
                });
                newUserModulePermissions.columns.push({
                    id: 'completedOn',
                    label: 'Completed On',
                    activityTrackerID: 0,
                    showPermission: true,
                    permission: null,
                    align: 'center',
                    completedCount:0,  
                    inCompletedCount:0, 
                });

                modules.map((item) => {
                    newUserModulePermissions.columns.push({
                        id: item.name.toLowerCase(),
                        label: item.name,
                        activityTrackerID: item.activityTrackerID,
                        showPermission: true,
                        permission: null,
                        showLabel: false,
                        align: 'center',
                        completedCount:0,  
                        inCompletedCount:0, 
                    });
                });
                let rowShow = 0;
                let usersData = [];
                users.map((user) => {
                    let rowObj = {
                        userName: {
                            label: user.userName,
                            userID: user.userID,
                            activityTrackerID: 0,
                            showPermission: false,
                            showLabel: true,
                            showChips: false,
                            permission: null,
                            align: 'left',
                        },
                        tags: {
                            label: user.userTags,
                            activityTrackerID: 0,
                            showPermission: false,
                            showLabel: false,
                            showChips: true,
                            permission: null,
                            align: 'center',
                        },
                        allModules: {
                            label: 'All Modules',
                            activityTrackerID: 0,
                            showPermission: true,
                            showLabel: false,
                            showChips: false,
                            permission: null,
                            align: 'center',
                        },
                        completedOn: {
                            label: 'Completed On',
                            activityTrackerID: 0,
                            showPermission: true,
                            completed: null,
                            completedDate: null,
                            showLabel: true,
                            showChips: false,
                            permission: null,
                            showCircle: false,
                            align: 'center',
                        },
                    };
                    if (modules) {
                        if (
                            modules.length > 0 &&
                            user.userActivityTrackerAccessTo.length > 0 &&
                            user.userActivityTrackerAccessTo.length ==
                            modules.length
                        ) {
                            let check = {};
                            user.userActivityTrackerAccessTo.forEach((perm) => {
                                check[perm.permission]
                                    ? check[perm.permission]++
                                    : 0;
                            });
                        }
                        modules.map((module) => {
                            if (
                                user.userActivityTrackerAccessTo &&
                                user.userActivityTrackerAccessTo.length > 0
                            ) {
                                let fIndex =
                                    user.userActivityTrackerAccessTo.findIndex(
                                        (row) => {
                                            return (
                                                row.activityTrackerID ==
                                                module.activityTrackerID
                                            );
                                        }
                                    );

                                if (fIndex > -1) {
                                    rowShow =
                                        user.userActivityTrackerAccessTo[fIndex]
                                            .status;
                                    rowObj[module.name.toLowerCase()] = {
                                        label: module.name,
                                        activityTrackerID: module.activityTrackerID,
                                        showPermission: true,
                                        permission:
                                            user.userActivityTrackerAccessTo[
                                                fIndex
                                            ].completed,
                                        status: user.userActivityTrackerAccessTo[
                                            fIndex
                                        ].status,
                                        showLabel: false,
                                        showChips: false,
                                        align: 'center',
                                        showCircle: true,
                                    };

                                    rowObj['completedOn'] = {
                                        label: user.userActivityTrackerAccessTo[
                                            fIndex
                                        ].completed
                                            ? Helper.FormatDate(
                                                user.userActivityTrackerAccessTo[
                                                    fIndex
                                                ].modifiedDate
                                            ) +
                                            ' ' +
                                            Helper.FormatTime(
                                                user.userActivityTrackerAccessTo[
                                                    fIndex
                                                ].modifiedDate
                                            )
                                            : null,
                                        activityTrackerID: module.activityTrackerID,
                                        showPermission: true,
                                        permission:
                                            user.userActivityTrackerAccessTo[
                                                fIndex
                                            ].completed,
                                        completed:
                                            user.userActivityTrackerAccessTo[
                                                fIndex
                                            ].completed,
                                        completedDate: user
                                            .userActivityTrackerAccessTo[fIndex]
                                            .completed
                                            ? user.userActivityTrackerAccessTo[
                                                fIndex
                                            ].modifiedDate
                                            : null,

                                        showLabel: true,
                                        showChips: false,
                                        showCircle: false,
                                        align: 'center',
                                    };
                                } else {
                                    rowShow = null;
                                    rowObj[module.name.toLowerCase()] = {
                                        label: module.name,
                                        activityTrackerID: module.activityTrackerID,
                                        showPermission: true,
                                        permission: null,
                                        status: null,
                                        showLabel: false,
                                        showChips: false,
                                        align: 'center',
                                        showCircle: true,
                                    };
                                    rowObj['completedOn'] = {
                                        label: 'Completed On',
                                        activityTrackerID: module.activityTrackerID,
                                        showPermission: true,
                                        permission: null,
                                        completed: 0,
                                        completedDate: null,
                                        showCircle: false,
                                        showLabel: true,
                                        showChips: false,
                                        align: 'center',
                                    };
                                }
                            } else {
                                rowShow = null;
                                rowObj[module.name.toLowerCase()] = {
                                    label: module.name,
                                    activityTrackerID: module.activityTrackerID,
                                    showPermission: true,
                                    permission: null,
                                    status: null,
                                    showLabel: false,
                                    showChips: false,
                                    align: 'center',
                                    showCircle: true,
                                };
                                rowObj['completedOn'] = {
                                    label: 'Completed On',
                                    activityTrackerID: module.activityTrackerID,
                                    showPermission: true,
                                    permission: null,
                                    completed: 0,
                                    completedDate: null,
                                    showLabel: true,
                                    showCircle: false,
                                    showChips: false,
                                    align: 'center',
                                };
                            }
                        });
                    }
                    (rowObj = {
                        ...rowObj,
                        showRow: {
                            showRow: rowShow,
                            activityTrackerID: 0,
                            showPermission: false,
                            showLabel: false,
                            showChips: false,
                            permission: null,
                            showCircle: false,
                        },
                    }),
                        //console.log('rowPbj', rowObj);
                        usersData.push(rowObj);
                });
                newUserModulePermissions.rows = usersData;
                // console.log(
                //     'newUserModulePermissions',
                //     newUserModulePermissions
                // );
                setUserModulePermissions(newUserModulePermissions);
            }
            setLoading(false);
        });
    };
    async function getAllData() {
        const modulesInfo = ApiHelper.get(
            APIURLConstants.GET_ACTIVITY_TRACKER_MARK_ACTIVITY_LIST(eventInfo.eventID)
        );
        const userModulesInfo = ApiHelper.get(
            APIURLConstants.GET_EVENT_ACTIVITY_TRACKER_MARK_ACTIVITIES(
                eventInfo.eventID
            )
        );
        let newUserModulePermissions = {
            columns: [],
            rows: [],
        };
        setLoading(false);
        await Promise.all([modulesInfo, userModulesInfo]).then((result) => {
            // console.log(
            //     'result[0].data[0].activityTrackerID',
            //     result[0].data[0].activityTrackerID
            // );
            let modules;
            if (selectedActivityID > 0) {
                modules = result[0].data.filter(
                    (user) =>
                        user.activityTrackerID ===
                        (selectedActivityID
                            ? selectedActivityID
                            : result[0].data[0].activityTrackerID)
                );
            } else {
                modules = result[0].data.filter((user) => user);
            }

            // console.log('modules', modules);
            // console.log('result', result);

            setActivityData(result[0].data);
            // console.log("modules",modules[0].activityTrackerID);
            // setSelectedActivityID(
            //     selectedActivityID === 0
            //         ? modules[0].activityTrackerID
            //         : selectedActivityID
            // );
            setSelectedActivityID(selectedActivityID);
            const users = result[1].data;
            setUsersData(users);
            if (modules.length > 0 && users.length > 0) {
                newUserModulePermissions.columns.push({
                    id: 'userName',
                    label: 'User',
                    activityTrackerID: 0,
                    showPermission: false,
                    permission: null,
                    align: 'left',
                });
                newUserModulePermissions.columns.push({
                    id: 'tags',
                    label: 'Tags',
                    activityTrackerID: 0,
                    showPermission: false,
                    permission: null,
                    align: 'center',
                });
                newUserModulePermissions.columns.push({
                    id: 'allModules',
                    label: 'All Media Circuit',
                    activityTrackerID: 0,
                    showPermission: true,
                    permission: null,
                    align: 'center',
                });
                newUserModulePermissions.columns.push({
                    id: 'completedOn',
                    label: 'Completed On',
                    activityTrackerID: 0,
                    showPermission: true,
                    permission: null,
                    align: 'center',
                });

                modules.map((item) => {
                    newUserModulePermissions.columns.push({
                        id: item.name.toLowerCase(),
                        label: item.name,
                        activityTrackerID: item.activityTrackerID,
                        showPermission: true,
                        permission: null,
                        showLabel: false,
                        align: 'center',
                    });
                });

                let usersData = [];
                let rowShow = 0;
                users.map((user) => {
                    let rowObj = {
                        userName: {
                            label: user.userName,
                            userID: user.userID,
                            activityTrackerID: 0,
                            showPermission: false,
                            showLabel: true,
                            showChips: false,
                            permission: null,
                            align: 'left',
                        },
                        tags: {
                            label: user.userTags,
                            activityTrackerID: 0,
                            showPermission: false,
                            showLabel: false,
                            showChips: true,
                            permission: null,
                            align: 'center',
                        },
                        allModules: {
                            label: 'All Modules',
                            activityTrackerID: 0,
                            showPermission: true,
                            showLabel: false,
                            showChips: false,
                            permission: null,
                            align: 'center',
                        },
                        completedOn: {
                            label: 'Completed On',
                            activityTrackerID: 0,
                            showPermission: true,
                            completed: null,
                            completedDate: null,
                            showLabel: true,
                            showChips: false,
                            permission: null,
                            showCircle: false,
                            align: 'center',
                        },
                    };
                    if (modules) {
                        if (
                            modules.length > 0 &&
                            user.userActivityTrackerAccessTo.length > 0 &&
                            user.userActivityTrackerAccessTo.length ==
                            modules.length
                        ) {
                            let check = {};
                            user.userActivityTrackerAccessTo.forEach((perm) => {
                                check[perm.permission]
                                    ? check[perm.permission]++
                                    : 0;
                            });
                        }
                        modules.map((module) => {
                            if (
                                user.userActivityTrackerAccessTo &&
                                user.userActivityTrackerAccessTo.length > 0
                            ) {
                                let fIndex =
                                    user.userActivityTrackerAccessTo.findIndex(
                                        (row) => {
                                            return (
                                                row.activityTrackerID ==
                                                module.activityTrackerID
                                            );
                                        }
                                    );
                                // console.log("boolean", user.userActivityTrackerAccessTo[fIndex].status);
                                if (fIndex > -1) {
                                    rowShow =
                                        user.userActivityTrackerAccessTo[fIndex]
                                            .status;
                                    rowObj[module.name.toLowerCase()] = {
                                        label: module.name,
                                        activityTrackerID: module.activityTrackerID,
                                        showPermission: true,
                                        permission:
                                            user.userActivityTrackerAccessTo[
                                                fIndex
                                            ].completed,
                                        status: user.userActivityTrackerAccessTo[
                                            fIndex
                                        ].status,
                                        showLabel: false,
                                        showChips: false,
                                        align: 'center',
                                    };
                                    rowObj['completedOn'] = {
                                        label: user.userActivityTrackerAccessTo[
                                            fIndex
                                        ].completed
                                            ? Helper.FormatDate(
                                                user.userActivityTrackerAccessTo[
                                                    fIndex
                                                ].modifiedDate
                                            ) +
                                            ' ' +
                                            Helper.FormatTime(
                                                user.userActivityTrackerAccessTo[
                                                    fIndex
                                                ].modifiedDate
                                            )
                                            : null,
                                        activityTrackerID: module.activityTrackerID,
                                        showPermission: true,
                                        permission:
                                            user.userActivityTrackerAccessTo[
                                                fIndex
                                            ].completed,
                                        completed:
                                            user.userActivityTrackerAccessTo[
                                                fIndex
                                            ].completed,
                                        completedDate: user
                                            .userActivityTrackerAccessTo[fIndex]
                                            .completed
                                            ? user.userActivityTrackerAccessTo[
                                                fIndex
                                            ].modifiedDate
                                            : null,

                                        showLabel: true,
                                        showChips: false,
                                        showCircle: false,
                                        align: 'center',
                                    };
                                } else {
                                    rowShow = null;
                                    rowObj[module.name.toLowerCase()] = {
                                        label: module.name,
                                        activityTrackerID: module.activityTrackerID,
                                        showPermission: true,
                                        permission: null,
                                        status: null,
                                        showLabel: false,
                                        showChips: false,
                                        align: 'center',
                                    };
                                    rowObj['completedOn'] = {
                                        label: 'Completed On',
                                        activityTrackerID: module.activityTrackerID,
                                        showPermission: true,
                                        permission: null,
                                        completed: 0,
                                        completedDate: null,
                                        showCircle: false,
                                        showLabel: true,
                                        showChips: false,
                                        align: 'center',
                                    };
                                }
                            } else {
                                rowShow = null;
                                rowObj[module.name.toLowerCase()] = {
                                    label: module.name,
                                    activityTrackerID: module.activityTrackerID,
                                    showPermission: true,
                                    permission: null,
                                    status: null,
                                    showLabel: false,
                                    showChips: false,
                                    align: 'center',
                                };
                                rowObj['completedOn'] = {
                                    label: 'Completed On',
                                    activityTrackerID: module.activityTrackerID,
                                    showPermission: true,
                                    permission: null,
                                    completed: 0,
                                    completedDate: null,
                                    showLabel: true,
                                    showCircle: false,
                                    showChips: false,
                                    align: 'center',
                                };
                            }
                        });
                    }
                    (rowObj = {
                        ...rowObj,
                        showRow: {
                            showRow: rowShow,
                            activityTrackerID: 0,
                            showPermission: false,
                            showLabel: false,
                            showChips: false,
                            permission: null,
                        },
                    }),
                        // console.log('rowPbj', rowObj);
                        usersData.push(rowObj);
                });
                // console.log("usersData", usersData);
                newUserModulePermissions.rows = usersData;
                // console.log(
                //     'newUserModulePermissions',
                //     newUserModulePermissions
                // );
                setUserModulePermissions(newUserModulePermissions);
            }
            setLoading(false);
        });
    }

    const setActivityID = (activityTrackerID) => {
        //console.log(activityTrackerID);
        setSelectedActivityID(activityTrackerID);
    };
    return (
        <Box sx={{ width: '100%' }}>
            {loading ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                    }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box className="contentBox">
                    {/* <Title title={' Activity Confirmation Tracker'} /> */}
                    {userModulePermissions &&
                        userModulePermissions.columns.length > 0 &&
                        userModulePermissions.rows.length > 0 ? (
                        <UserMediaCircuitList
                            {...props}
                            data={userModulePermissions}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            getAllData={getAllData}
                            onChangeMediaCircuitActivities={
                                onChangeMediaCircuitActivities
                            }
                            activitiesData={activityData}
                            selectedActivityID={selectedActivityID}
                            generateExcelReport={generateExcelReport}
                            setActivityID={setActivityID}
                        />
                    ) : (
                        <ListItem className={classes.listItemContent}>
                            <Card
                                classes={{ root: classes.paperContent }}
                                sx={{ width: '100%' }}>
                                <CardContent
                                    sx={{ p: 2 }}
                                    className={classes.cardContent}>
                                    <Box className={classes.rowContent}>
                                        Please select the participant and
                                        modules for event
                                    </Box>
                                </CardContent>
                            </Card>
                        </ListItem>
                    )}
                </Box>
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: false,
                        })
                    }></CustomizedSnackbars>
            )}
        </Box>
    );
};
export default MarkActivitiyList;
// {
//     routeProps: {
//         path: RouteConstants.COMBINE_MARK_ACTIVITIES,
//         component: CombineMarkActivitiy,
//     },
//     name: 'CombineMarkActivitiy',
// };
